import AppDialog from '../app_dialog'
import { TextField, Alert } from '@cinesend/ui-kit'
import { useState } from 'react'

const DeleteConfirmationModal = ({ cycle, errors, onClose, onConfirm }) => {
  const [airlineGroupCode, setAirlineGroupCode] = useState('')

  return (
    <AppDialog
      title='Confirm cycle deletion'
      onClose={() => onClose()}
      confirmText='Confirm'
      onConfirm={() => onConfirm(cycle?.id, airlineGroupCode)}
      confirmDisabled={!airlineGroupCode || airlineGroupCode !== cycle?.airline.group_code}
      confirmVariant='destructive'
    >
      <p>
        Are You Sure you want to delete cycle <span className='font-bold'>{cycle?.name}</span>?
      </p>
      <p className='pb-4'>{cycle?.description}</p>
      <TextField
        label={`Enter the Group Code to delete`}
        value={airlineGroupCode}
        onChange={(e) => setAirlineGroupCode(e.target.value)}
        autoFocus
      />
      <br />
      {errors && (
        <Alert tone='info' size='sm'>
          <ul className={errors.length > 1 ? 'list-disc list-inside' : 'list-none'}>
            {errors.map((error, index) => (
              <li className='' key={`cycle-deletion-${index}`}>
                {error}
              </li>
            ))}
          </ul>
        </Alert>
      )}
    </AppDialog>
  )
}

export default DeleteConfirmationModal
